import { Renderer } from "@with-nx/cms-ui";
import { ReusableSection } from "@with-nx/simple-ui/atoms";
import { Rule } from "@with-nx/simple-ui/atoms";
import { CatalogLayout } from "@with-nx/simple-ui/organisms";
import { Col, Row } from "antd";

import LegalMenuDesktop from "../../components/w/LegalMenuDesktop";

export default function Page() {
  return (
    <CatalogLayout
      footerNoAngle
      title="Broadway Media - Submissions"
      description="This Submissions document was last updated on June 30, 2023"
    >
      <ReusableSection>
        <div className="container mx-auto max-w-7xl">
          <Row gutter={[36, 18]} justify="space-between">
            <Col xs={24} sm={24} md={24} lg={6} xl={6}>
              <LegalMenuDesktop />
            </Col>
            <Col xs={24} sm={24} md={24} lg={18} xl={18}>
              <Rule rule="hs" color="var(--font1)" display="block" bottom={24}>
                Support Policy
              </Rule>
              <Rule rule="ls" color="var(--font3)" display="block" bottom={24}>
                This Support Policy document was last updated on October 03,
                2023
              </Rule>

              <Renderer
                data={{
                  blocks: [
                    {
                      type: "bold",
                      data: {
                        text: `1. Introduction`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: 'This Support Policy outlines the terms and conditions under which Broadway Media Distribution, Inc, doing business as "Broadway Media" ("we," "our," or "the Company"), provides support services for all software applications and websites offered to customers and accessible by our customers ("the Software"). By utilizing our support services, you ("the Customer") agree to abide by the terms and conditions outlined in this policy.',
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `2. Support Services`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `2.1. <strong>Scope of Support</strong>: Our support services include assistance with troubleshooting and resolving issues related to the Software, guidance on usage, and addressing questions regarding its features and functionalities.`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `2.2. <strong>Eligibility</strong>: To be eligible for support, the Customer must maintain an active and valid subscription or support agreement for the Software.`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `2.3. <strong>Support Channels</strong>: Support will be provided through email at help@broadwaymedia.com, our online support portal, and, if applicable, phone support at (559) 475-9455 during our standard support hours.`,
                      },
                    },

                    {
                      type: "bold",
                      data: {
                        text: `3. Support Hours`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `Our standard support hours are 8am to 5pm EST, Monday to Friday. We are closed on most holidays.`,
                      },
                    },

                    {
                      type: "bold",
                      data: {
                        text: `4. Response Time`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `4.1. <strong>Severity Levels</strong>: Support requests will be categorized into the following severity levels:`,
                      },
                    },
                    {
                      type: "list",
                      unordered: true,
                      data: {
                        text: [
                          `<strong>Critical</strong>: Service is unavailable or severely impacted.`,
                          `<strong>High</strong>: Significant functionality is impaired.`,
                          `<strong>Medium</strong>: A moderate issue affecting specific functionality.`,
                          `<strong>Low</strong>: General inquiries or non-critical issues.`,
                        ],
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `4.2. Response Time Targets: We aim to respond to support requests during business hours based on their severity level as follows:`,
                      },
                    },
                    {
                      type: "list",
                      unordered: true,
                      data: {
                        text: [
                          `<strong>Critical</strong>: Within 1 day.`,
                          `<strong>High</strong>: Within 2 days.`,
                          `<strong>Medium</strong>: Within 5 days.`,
                          `<strong>Low</strong>: Within 30 days.`,
                        ],
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `5. Support Exclusions`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `Support services do not cover:`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `5.1. Issues arising from:`,
                      },
                    },
                    {
                      type: "list",
                      unordered: true,
                      data: {
                        text: [
                          `Unauthorized modifications to the Software.`,
                          `Third-party integrations or components.`,
                          `Hardware or network failures not under our control.`,
                          `Other known bugs or concerns that we are currently addressing.`,
                        ],
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `5.2. Training or customization services.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `6. Software Updates`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `We periodically release updates and patches for the Software. Support includes assistance with updating to the latest version.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `7. Billing and Payments`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `7.1. Payment for support services is due in accordance with the terms specified in the Customer's subscription or support agreement.`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `7.2. Failure to make payments may result in a suspension of support services.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `8. Termination of Support`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `We reserve the right to terminate support services if the Customer violates the terms of this policy or the subscription/support agreement.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `9. Confidentiality`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `All information shared during the support process will be treated as confidential.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `10. Limitation of Liability`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `We will make reasonable efforts to provide support, but we do not guarantee the resolution of all issues. Our liability is limited to the terms outlined in our subscription/support agreement.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `11. Amendments`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `We may update this Support Policy as needed. Customers will be notified of any changes, and the revised policy will be made available on our website.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `12. Contact Information`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `For support inquiries or questions regarding this policy, please contact us at:`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `Email: help@broadwaymedia.com Phone: (559) 475-9455`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `By availing of our support services, you acknowledge that you have read, understood, and agree to comply with the terms and conditions outlined in this Support Policy.`,
                      },
                    },
                  ],
                }}
              />
            </Col>
          </Row>
        </div>
      </ReusableSection>
    </CatalogLayout>
  );
}
